import { 
    CONTRACT_BEGIN,
    CONTRACT_ADD,
	CONTRACT_FAILURE,
} from 'app/actions/ContractActions';

const initialState = {
	byId: {},
	allIds: [],
	isLoading: false,
};

export default function ContractReducer (state = initialState, action) {
	switch (action.type) {
        case CONTRACT_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case CONTRACT_ADD: 
			let allIds = [...new Set(state.allIds.concat(action.payload.data.allIds))];
			let byId = {
				...state.byId,
				...action.payload.data.byId
			};
			return {
				...state,
				allIds,
				byId,
				isLoading: false,
			};
        case CONTRACT_FAILURE: 
			return {
				...state,
				isLoading: false
			}
        
		default:
			return state;
	}
};

export const getContract = state => {
	return state.allIds.map( id => state.byId[id] );
}

export const contractSummaryError = state => {
    return state.error;
}